export interface ScrollBelowAppChromeOptions {
  /** Scroll behavior; defaults to 'auto'. */
  behavior?: ScrollBehavior;
}

/**
 * Scrolls the window so the element's top border aligns just below the sticky
 * app nav and calculator tab bar (#app-nav + #calculator-tab-bar).
 */
export function scrollElementTopBelowAppChrome(
  selectorOrElement: string | HTMLElement,
  options: ScrollBelowAppChromeOptions = {},
): void {
  const { behavior = 'auto' } = options;

  const el =
    typeof selectorOrElement === 'string'
      ? document.querySelector(selectorOrElement)
      : selectorOrElement;
  if (!(el instanceof HTMLElement)) return;

  const nav = document.getElementById('app-nav');
  const tabBar = document.getElementById('calculator-tab-bar');
  const stickyChrome =
    (nav?.getBoundingClientRect().height ?? 0) + (tabBar?.getBoundingClientRect().height ?? 0);

  const rect = el.getBoundingClientRect();
  const y = window.scrollY + rect.top - stickyChrome;

  window.scrollTo({ top: Math.max(0, y), behavior });
}
